import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import Swal from 'sweetalert2';
import { QuizService } from '../services/quiz.service';


@Component({
  selector: 'app-employment-check',
  templateUrl: './employment-check.component.html',
  styleUrls: ['./employment-check.component.css']
})
export class EmploymentCheckComponent implements OnInit {

  candidateDetails : any;



   formData: any = {    dateOfCompletion: new Date().toISOString().substring(0, 10)};

empId:any;
questions:any;
uniqueCode:any;
  isSubmitted = false;

  constructor(public toastr: ToastrManager, private quizService: QuizService, private route: ActivatedRoute) {}

ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(params);
      if (params['empId'] != null) {
        sessionStorage.setItem('empId', params['empId']);
        //localStorage.setItem('stateOfUser', 'abcde');
      }
    });
    this.empId = sessionStorage.getItem('empId');//'F3C4F5'; //'1BE3D2';'7AC0E0';
    this.GetEmpReasons(this.empId);
    this.loadQuestions(this.empId);
    this.loadEmpDetails(this.empId);
  }

   loadEmpDetails(uniqueCode: string) {
    this.quizService.GetEmpDetailsService(uniqueCode).subscribe((res: any) => {
      this.candidateDetails = res;
  
      });
    
  }

  loadQuestions(uniqueCode: string) {
    this.quizService.GetEmpService(uniqueCode).subscribe((res: any[]) => {
      this.questions = res.map((q:any) => {
        this.uniqueCode = uniqueCode;
        return {
       ...q,
      //inputType:  this.quizService.determineInputType(q)
      };
  
      });
    });
  }
GetEmpReasons(code: string) {
  this.quizService.GetEmpResults(code).subscribe((ta: any[]) => {
    if (Array.isArray(ta) && ta.length > 0) {
      this.questions = ta;

      this.questions.forEach(q => {
        // Default mapping
        this.formData[q.questionId] = q.selectedAnswer;
        if (q.additionalComments) {
          this.formData[q.questionId + 'Comments'] = q.additionalComments;
        }

        // Special case: Q3 correction input
        if (q.questionNumber === 3 && q.dynamicValue) {
          this.formData[q.questionId + 'CorrectText'] = q.dynamicValue;
        }

        // Special case: Q4 correction inputs
        if (q.questionNumber === 4 && q.dynamicValue) {
          const parts = q.dynamicValue.split(' - ').map(p => p.trim());
          this.formData.q4StartDate = parts[0] || '';

          if (parts[1]) {
            if (parts[1].includes('Currently Employed')) {
              this.formData.q4CurrentlyEmployed = true;
              this.formData.q4EndDate = this.formatDateMMDDYYYY(new Date());
            } else {
              this.formData.q4EndDate = this.formatDateMMDDYYYY(new Date(parts[1]));
              this.formData.q4CurrentlyEmployed = false;
            }
          }
        }

        // Special case: Q11 signature + date
        if (q.questionNumber === 11 && q.dynamicValue) {
          const sigMatch = q.dynamicValue.match(/Signature:\s*([^,]*)/);
          const dateMatch = q.dynamicValue.match(/Date:\s*(.*)$/);

          this.formData.signature = sigMatch ? sigMatch[1].trim() : '';

          const parsedDate = dateMatch && dateMatch[1].trim() ? new Date(dateMatch[1].trim()) : new Date();
          this.formData.dateOfCompletion = this.formatDateMMDDYYYY(parsedDate);

          this.formData.q11Confirm = q.selectedAnswer === 'Yes, I confirm';
        }
      });

      // ✅ Show Swal once after processing
      Swal({
        title: 'Employment Verification Completed',
        text: 'You have completed this already.',
        type: 'success',
        showCloseButton: true,
        confirmButtonText: 'OK',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value || result.dismiss === Swal.DismissReason.close) {
          window.location.replace('https://arytic.co'); // safer redirect
        }
      });
    }
  });
}

// ✅ Helper for MM-DD-YYYY
private formatDateMMDDYYYY(date: Date): string {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
}
  // Handle form submission
submitForm(payload: any) {
if(payload)
{
this.isSubmitted = true;
console.log('Employment Verification Form Submitted', payload);

payload.forEach((answer: any) => {
  this.quizService.PostEmpService(answer).subscribe((data: any) => {
    console.log('Saved answer:', data);
  });
});

// After all answers are sent, show success popup
//const candidateName = `${this.candidateDetails.FullName}`;
Swal({
  title: 'Verification Submitted!',
  text: `Thank you for completing the employment verification`,
  type: 'success',
  showCloseButton: true,
  confirmButtonText: 'OK',
  allowOutsideClick: false
}).then((result) => {

        // ✅ Send Admin Email
      const adminEmailPayload = {
        FromId:"donotreply@arytic.com" ,
        ToEmailId:  "info@arytic.com", // admin email
        CandidateName: this.candidateDetails.FullName,
        CandidateId: this.candidateDetails.ProfileId.toString(),
        RequestId: this.candidateDetails.EmpRequestId.toString(),
        CompanyName: this.candidateDetails.CompanyName,
        RequestLink: `https://arytic.co/arytic-check`
      };
      this.quizService.PostAdminEmailService(adminEmailPayload)
        .subscribe(() => console.log("Admin email sent"));
 
  this.GetEmpReasons(this.empId);
  if (result.value || result.dismiss === Swal.DismissReason.close) {
      window.location.href = 'https://arytic.co';
            //window.close();
  }
  // const candidateEmailPayload = {
  //       FromId: "info@arytic.com",
  //       //ToEmailId: this.candidateDetails.Email, // or fixed dev email for testing
  //         ToEmailId: "developer.arytic@gmail.com", // admin email
  //       CandidateName: this.candidateDetails.FullName,
  //       RequestId: this.candidateDetails.EmpRequestId.toString(),
  //       Title: this.candidateDetails.Designation,
  //       CompanyName: this.candidateDetails.CompanyName,
  //       RequestLink: `https://candidate.arytic.com/login`
  //     };
  //     this.quizService.PostCandidateEmailService(candidateEmailPayload)
  //       .subscribe(() => console.log("Candidate email sent"));


   });

}else {
    //const candidateName = `${this.candidateDetails.firstName} ${this.candidateDetails.lastName}`;
  Swal({
    title: 'Verification Not Submitted!',
    text: `Thank you for completing the employment verification.`,
    type: 'info',
    showCloseButton: true,
    confirmButtonText: 'OK',
    allowOutsideClick: false
  }).then((result) => {
    if (result.value || result.dismiss === Swal.DismissReason.close) {
      window.open('https://arytic.co', '_blank');
    }
  });
    }
  
}

  isFormValid(): boolean {
    if (this.formData.q1Confirm === false || this.formData.q2Confirm === false) {
      return true;
    }

    // Check key fields
    const q1 = this.formData.q1Confirm !== null;
    const q2 = this.formData.q2Confirm !== null;
    // We can be strict or loose. Let's ensure at least signature + confirmation for happy path
    const end = this.formData.q11Confirm && this.formData.signature;

    return q1 && q2 && !!end;
  }

resetForm() {
  this.formData = {};        // clear all answers
  this.isSubmitted = false;  // reset submission state
}

}
